// The form builder renderer's fixed numbers and tables (spec §7, §8). Plain module: no React, no aliases, no CSS - it
// runs under `node --test` (see ../../form-helper for why this file imports it relatively).
import { GRID_SIZES, DEFAULT_GRID, MOBILE_GRID, LIMITS } from "./form_helper.js";

// repeatable group: at least one instance always stays, at most ten (spec §4, a number in the code, not a setting)
export const REPEAT_MIN = 1;
export const REPEAT_MAX = LIMITS.REPEAT_MAX;

// the mobile layout starts below this width; it is done in CSS (a media query), never in JS (spec §7)
export const MOBILE_BREAKPOINT_PX = 640;

// `grid` of a field -> the class name key of the default CSS module; the mobile mapping is in the CSS too
export const GRID_KEYS = Object.freeze({ 3: "grid_3", 4: "grid_4", 6: "grid_6", 12: "grid_12" });

export const grid_of = (field) => (GRID_SIZES.includes(field?.grid) ? field.grid : DEFAULT_GRID);
export const mobile_grid_of = (field) => MOBILE_GRID[grid_of(field)];

// the slots every field type accepts in `styles.<type>` (spec §8)
export const FIELD_SLOTS = Object.freeze(["root", "label", "input", "hint", "error"]);
export const GROUP_SLOTS = Object.freeze(["root", "title", "description", "grid", "instance", "actions", "button"]);
export const FORM_SLOTS = Object.freeze(["root", "title", "description", "error", "actions", "submit", "success", "notice"]);

// how each fixed typed field is typed into: the html input type and the on-screen keyboard
export const TEXT_FIELD_KINDS = Object.freeze({
    text: { input_type: "text", input_mode: "text", dir: undefined, autocomplete: undefined },
    mobile: { input_type: "tel", input_mode: "tel", dir: "ltr", autocomplete: "tel" },
    email: { input_type: "email", input_mode: "email", dir: "ltr", autocomplete: "email" },
    national_code: { input_type: "text", input_mode: "numeric", dir: "ltr", autocomplete: "off" },
    postal_code: { input_type: "text", input_mode: "numeric", dir: "ltr", autocomplete: "postal-code" },
    number: { input_type: "text", input_mode: "decimal", dir: "ltr", autocomplete: "off" },
    price: { input_type: "text", input_mode: "numeric", dir: "ltr", autocomplete: "off" },
});

// The largest file the browser sends by default. FormHelper (and the spec) allow 5 MB, but the file travels as base64 inside
// the JSON of createFormSubmission and the public API refuses a request above 5 MB (a third larger than the file), so a
// 5 MB file would get an opaque 413. 3.5 MB leaves room for the other values and the meta. A site whose server allows
// more passes `max_file_bytes` to useFormRenderer.
export const DEFAULT_MAX_FILE_BYTES = Math.round(3.5 * 1024 * 1024);

// the file input's `accept`: the extensions the server accepts (spec §8)
export const FILE_ACCEPT = ".jpg,.jpeg,.png,.webp,.gif,.pdf,.doc,.docx";

export const FORM_PLACE = "form"; // the captcha place the server uses for forms
